import React from "react";
import Footer from "../home/Footer";
import Header from "../../views/Header";

const CancellationRefund = () => {
  return (
    <div>
      {/* <Header/> */}
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-black text-center mt-8 md:mt-12 mb-8 text-4xl font-bold font-Cinzel">
            Cancellation and Refund Policy
          </h1>
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="p-6 sm:p-8 space-y-6 text-gray-800 font-Outfit text-sm sm:text-md">
              <p>
                We’re so confident you’ll love the products that we offer thus,
                the situation of cancellation and refund may arise due to any
                circumstances. Sometimes you suddenly realise that you don’t
                require that product any more then you have to inform us within
                8 hours of placing the order so that we can stop the order from
                being shipped in our system. If the order I already shipped and
                you try to cancel the order then we would have to depend on
                courier if they can cancel the shipping and return the product
                to us and we can cancel the order but in case shipping if not
                cancellable then you have to refuse the delivery and shipment
                will automatically return to us and order will be cancelled.
              </p>
              <p>
                If the order is delivered at your doorstep then the cancelation
                is not possible (except damage or defective cases) and return
                cost will be paid by you if you still wish to cancel the order.
              </p>
              <p>
                All the payments will be refunded to your bank account within 7
                to 10 working days which you would have to provide us at the
                time of cancelation.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CancellationRefund;
